module.exports = "https://static.wagwalking.com/_next/static/images/training-bouncer-avatar-70fccb2a5474429efab8a498d00bdf6e.png";